import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';

import { getUnstakePeriodDays } from '../methods/getUnstakePeriodDays';

export const { useGetUnstakePeriodQuery } = api.injectEndpoints({
  endpoints: build => ({
    getUnstakePeriod: build.query<BigNumber, { poolAddress: Address }>({
      queryFn: async ({ poolAddress }) => {
        try {
          const client = getPublicClient();

          return { data: await getUnstakePeriodDays(client, poolAddress) };
        } catch {
          const client = getPublicClient();

          return { data: await getUnstakePeriodDays(client, poolAddress) };
        }
      },
      providesTags: [],
    }),
  }),
});
